import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../../../../../style';

const updateSiteLogoFormBorderWidth = 1;
const updateSiteLogoFormInnerWidth = 600 - updateSiteLogoFormBorderWidth*2;

const updateSiteLogoFormInnerNavPanelWidth = 240; //  from NavigationStyles OpenPanelWidth
const updateSiteLogoFormInnerMinimizedNavPanelWidth = 66; // From NavigationStyles MinimizedPanelWidth

export namespace FormStyles {

  export const errorStateBackgroundColor = applyColor(DesignTokens.color.elevation.surface.default.subtle, CommonStyles.Colors.Grey245);
  export const defaultStateBackgroundColor = applyColor(DesignTokens.color.elevation.surface.default.default, TabStyles.Colors.White);

  export const pointerCursor: React.CSSProperties = {
    cursor: 'pointer',
  };

  export const buttonSpacing: React.CSSProperties = {
    marginLeft: TabStyles.Spacing.SmallSpace,
    marginRight: TabStyles.Spacing.SmallSpace,
    ...pointerCursor,
  };

  export const centerAlignText: React.CSSProperties = {
    textAlign: 'center'
  };

  export const centerJustifyContent: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
  };

  export const alignFormContent: React.CSSProperties = {
    marginBottom: 20,
    marginTop: 20,
    verticalAlign: 'middle',
    ...centerJustifyContent
  };

  export const updateLogoRegionStyles: React.CSSProperties = {
    position: 'relative',
    width: updateSiteLogoFormInnerWidth,
    height: 'auto',
    borderWidth: updateSiteLogoFormBorderWidth,
    borderStyle: 'solid',
    borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.Grey225),
    ...centerAlignText
  };

  export const displayFilenameTextStyles: React.CSSProperties = {
    width: updateSiteLogoFormInnerWidth - TabStyles.Spacing.ExtraLargeSpace*2,
    paddingTop: TabStyles.Spacing.ExtraLargeSpace,
    paddingBottom: TabStyles.Spacing.ExtraLargeSpace,
    paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
    paddingRight: TabStyles.Spacing.ExtraLargeSpace,
    fontSize: 20,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };

  export const errorTextStyles: React.CSSProperties = {
    paddingTop: 0,
    color: applyColor(DesignTokens.color.font.default.error, TabStyles.Colors.AttentionDark),
  };

  export const previewTextPadding: React.CSSProperties = {
    marginBottom: 10,
    marginTop: 40
  };

  export const previewDropTargetPadding: React.CSSProperties = {
    marginLeft: 10,
    marginRight: 10
  };

  export const doNotDisplay: React.CSSProperties = {
    display: 'none'
  };

  const logoPreviewStyles: React.CSSProperties = {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, CommonStyles.Colors.Grey250), // from NavigationStyles LeftPanel background color
    paddingTop: 28,  // from NavigationStyles LeftPanel paddingTop
    paddingBottom: 24, // from NavigationStyles LogoMarginBottom
    display: 'flex',
    justifyContent: 'center'
  };

  export const headerLogoPreviewClass = cssClass('HeaderLogoPreview','', {
    width: updateSiteLogoFormInnerNavPanelWidth,
    ...logoPreviewStyles
  });

  export const compactLogoPreviewClass = cssClass('CompactLogoPreview', '', {
    width: updateSiteLogoFormInnerMinimizedNavPanelWidth,
    ...logoPreviewStyles
  });

  export const dropTargetHighlightingClass = cssClass('LogoPreview', '', {
    backgroundColor: applyColor(DesignTokens.color.component.background.cta.default.default, CommonStyles.Colors.HyperlinkBlueHover),
  });
}
